import React, { Component } from 'react';
import { Card, FormLabel } from 'react-bootstrap';
import { ResponsivePie } from '@nivo/pie';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

const colors = ['#39cd33', '#eae825', '#820ad1', '#ff873d', '#e41b1d'];

class Potential extends Component {
	renderTooltip = (d) => {
		const labelSplit = d.label.split(':');

		return (
			<div style={{ whiteSpace: 'pre', display: 'flex', alignItems: 'center' }}>
				<span
					style={{
						display: 'block',
						width: '12px',
						height: '12px',
						background: d.color,
						marginRight: '7px',
					}}
				></span>
				{`${labelSplit[0]}, qtd: ${labelSplit[1] ? labelSplit[1] : 0} - `}
				<strong>{`R$ ${this.props.toBrCurrency(d.value)}`}</strong>
			</div>
		);
	};

	render() {
		const {
			collection,
			isRepFilled,
			// tip
		} = this.props;
		return (
			<div className="div-indicador">
				<IsRepFilledDiv isRepFilled={isRepFilled}>
					<Card style={{ width: '100%' }}>
						<Card.Header style={{ fontWeight: 'bold' }}>
							Potencial
							{/* <div data-tip={tip} className="fas fa-info-circle ml-1" /> */}
						</Card.Header>
						<Card.Body>
							<div className="pie">
								<ResponsivePie
									data={collection}
									sliceLabel={(e) => {
										return 'R$ ' + this.props.toBrCurrency(e.value);
									}}
									margin={{ top: 0, right: 0, bottom: 0, left: 10 }}
									innerRadius={0.35}
									padAngle={2}
									slicesLabelsSkipAngle={45}
									colors={colors}
									borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
									enableRadialLabels={false}
									animate={true}
									motionStiffness={90}
									motionDamping={15}
									tooltip={(d) => this.renderTooltip(d)}
									legends={[
										{
											anchor: 'bottom-left',
											direction: 'column',
											translateY: 0,
											translateX: -10,
											itemWidth: 20,
											itemHeight: 14,
											itemTextColor: '#999',
											symbolSize: 10,
											symbolShape: 'circle',
											effects: [
												{
													on: 'hover',
													style: {
														itemTextColor: '#000',
													},
												},
											],
										},
									]}
								/>
							</div>
						</Card.Body>
					</Card>
				</IsRepFilledDiv>
			</div>
		);
	}
}

export default Potential;

const IsRepFilledDiv = (props) => {
	if (props.isRepFilled) return props.children;

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				position: 'relative',
			}}
		>
			{!props.isRepFilled && (
				<>
					<div
						style={{
							display: 'flex',
							width: '100%',
							height: '100%',
							position: 'absolute',
							opacity: '60%',
							padding: '0px 15px 15px 15px',
							zIndex: 90,
							backgroundColor: '#FFFFFFFF',
						}}
					></div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							height: '100%',
							alignItems: 'center',
							justifyContent: 'center',
							position: 'absolute',
							padding: '0px 15px 15px 15px',
							zIndex: 91,
						}}
					>
						<FormLabel style={{ fontSize: '20px' }}>
							Preencha representante
						</FormLabel>
					</div>
				</>
			)}
			{props.children}
		</div>
	);
};
